import React, { useEffect, useRef, useState } from 'react'

export const Row = ({ label, hint, children, inline }) => (
  <div className={`fb-prop${inline ? ' is-inline' : ''}`}>
    {label && <label className="fb-prop-label">{label}</label>}
    <div className="fb-prop-control">{children}</div>
    {hint && <div className="fb-prop-hint">{hint}</div>}
  </div>
)

export const Group = ({ title, children, actions }) => (
  <div className="fb-group">
    {(title || actions) &&
      <div className="fb-group-head">
        <span>{title}</span>
        {actions}
      </div>
    }
    {children}
  </div>
)

export const Toggle = ({ checked, onChange, label, hint, disabled }) => (
  <label className={`fb-toggle${disabled ? ' is-disabled' : ''}`}>
    <input type="checkbox" checked={!!checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />
    <span className="fb-switch" />
    <span className="fb-toggle-text">
      {label}
      {hint && <small>{hint}</small>}
    </span>
  </label>
)

export const Segmented = ({ value, options, onChange, disabled }) => (
  <div className="fb-segmented is-small">
    {options.map(([optionValue, label, title]) => (
      <button
        key={optionValue}
        type="button"
        title={title}
        disabled={disabled}
        className={value === optionValue ? 'active' : ''}
        onClick={() => onChange(optionValue)}
      >
        {label}
      </button>
    ))}
  </div>
)

// Keeps what is typed until it parses, so "1." or "" never jumps back
export const NumberInput = ({ value, onChange, min, max, step = 1, suffix, disabled, placeholder }) => {
  const [text, setText] = useState(value === null || value === undefined ? '' : String(value))
  const focused = useRef(false)

  useEffect(() => {
    if (!focused.current) { setText(value === null || value === undefined ? '' : String(Math.round(value * 100) / 100)) }
  }, [value])

  return (
    <div className="fb-number">
      <input
        type="number"
        className="fb-input"
        value={text}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        placeholder={placeholder}
        onFocus={() => { focused.current = true }}
        onBlur={() => { focused.current = false; setText(value === null || value === undefined ? '' : String(Math.round(value * 100) / 100)) }}
        onChange={(event) => {
          setText(event.target.value)
          if (event.target.value === '') { onChange(null); return }
          const number = parseFloat(event.target.value)
          if (!Number.isNaN(number)) { onChange(number) }
        }}
      />
      {suffix && <span className="fb-number-suffix">{suffix}</span>}
    </div>
  )
}

export const TextArea = ({ value, onChange, placeholder, disabled, autoFocus }) => {
  const ref = useRef(null)
  useEffect(() => {
    if (!ref.current) { return }
    ref.current.style.height = 'auto'
    ref.current.style.height = `${ref.current.scrollHeight + 2}px`
  }, [value])

  return (
    <textarea
      ref={ref}
      className="fb-input"
      rows={1}
      value={value || ''}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      onChange={(event) => onChange(event.target.value)}
    />
  )
}
